import { ref } from 'vue';
import axios from 'axios';

const complexTree = ref([]);
const ticked = ref([]);
const expanded = ref([]);

export default function useComplexTree() {
  const fetchComplexTree = async (sessionId = -1) => {
    try {
      const url = `${process.env.VUE_APP_HOUSING_SERVICE_URL}/api/complextree`;
      const response = await axios.get(url, {
        params: {
          sessionId,
        },
      });
      const { data } = response;
      complexTree.value = data;
    } catch (error) {
      console.log(error);
    }
  };

  const resetTicks = () => {
    ticked.value.length = 0;
  };

  const populateTreeTicks = async (complexModel, unitModel) => {
    ticked.value.length = 0;

    if (complexModel) {
      for (let i = 0; i < complexModel.length; i += 1) {
        ticked.value.push(`Complex:${complexModel[i].complexId}`);
      }
    }
    if (unitModel) {
      for (let i = 0; i < unitModel.length; i += 1) {
        ticked.value.push(`Unit:${unitModel[i].unitId}`);
      }
    }
  };

  return {
    complexTree,
    fetchComplexTree,
    populateTreeTicks,
    resetTicks,
    ticked,
    expanded,
  };
}
